import Combobox from '@ls/react-combobox-grid';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {calcTypeOptions} from 'state/Constants/CalcType';
import {
  selectFetchingTraceAnalyticValues,
  selectFetchingTracePeriodValues,
  selectTraceAnalyticOptions,
  selectTracePeriodOptions,
} from 'state/traceAnalytics/selectors';
import {Cell, Grid} from 'styled-css-grid';

const TraceAnalyticsComplication = ({setDefinition, definition}) => {
  const fetchingTraceAnalyticValues = useSelector(selectFetchingTraceAnalyticValues);
  const fetchingTracePeriodValues = useSelector(selectFetchingTracePeriodValues);
  const traceAnalyticOptions = useSelector(selectTraceAnalyticOptions);
  const tracePeriodOptions = useSelector(selectTracePeriodOptions);

  const [setTraceAnalytic, setTracePeriod, setCalcType] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setTraceAnalytic(value)),
      (value) => setDefinition(definition.setTracePeriod(value)),
      (value) => setDefinition(definition.setCalcType(value)),
    ];
  }, [definition, setDefinition]);
  return (
    <Grid columns={12} gap="4px">
      <Cell width={6}>
        <Combobox
          options={traceAnalyticOptions}
          onChange={setTraceAnalytic}
          isLoading={fetchingTraceAnalyticValues}
          value={definition.traceAnalytic}
          label="Trace Analytic:"
          variation={0}
          size={'S'}
          gridHeight={250}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={tracePeriodOptions}
          onChange={setTracePeriod}
          isLoading={fetchingTracePeriodValues}
          value={definition.tracePeriod}
          label="Days:"
          variation={0}
          size={'S'}
          gridHeight={200}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={calcTypeOptions}
          onChange={setCalcType}
          value={definition.calcType}
          label="Calc:"
          clearable={false}
          variation={0}
          size={'S'}
          gridHeight={120}
        />
      </Cell>
    </Grid>
  );
};

TraceAnalyticsComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(TraceAnalyticsComplication);
